// src/views/privacy.ts
import { html, type TemplateResult } from 'lit-html';

export function renderPrivacy(): TemplateResult {
  return html`
    <div class="container">
      <h2>隐私说明 🔒</h2>

      <section class="result-section">
        <p class="result-tagline">"所有测试数据都存在你的浏览器里,我们看不到。"</p>
      </section>

      <section class="result-section">
        <h3>我们不做的事</h3>
        <ul>
          <li>❌ 不要求注册账号</li>
          <li>❌ 不收集姓名、邮箱、手机号、IP 地址</li>
          <li>❌ 不使用 Google Analytics 等第三方追踪</li>
          <li>❌ 不投放广告</li>
          <li>❌ 不向任何人分享你的数据</li>
          <li>❌ 不把任何答题数据上传到服务器</li>
        </ul>
      </section>

      <section class="result-section">
        <h3>我们做的事</h3>
        <ul>
          <li>✅ 使用浏览器的 <strong>localStorage</strong> 保存你的答题进度和最近 5 次测试结果 (仅在你这台设备的浏览器内)</li>
          <li>✅ 服务器层有 Cloudflare 自带的访问计数 (聚合统计,不识别个人用户)</li>
        </ul>
      </section>

      <section class="result-section">
        <h3>如何清除数据</h3>
        <ul>
          <li>清空 localStorage:浏览器开发者工具 → Application → Local Storage → 删除以 <code>vark.</code> 开头的项</li>
          <li>或直接清除浏览器站点数据,所有测试痕迹立即消失</li>
        </ul>
      </section>

      <p><a href="#/">← 回首页</a></p>
    </div>
  `;
}
